export default __webpack_public_path__ + "static/media/action_btn_circle_facebook@3x.efd8ce02.png";